import { NetError } from '@/features/errors'

export const OtherErrorView = () => {
  return <NetError />
}
